import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { routePaths } from "../constants/routes";
import "../style/unauthorized.css";

export default function UnauthorizedPage() {
  const location = useLocation();
  const { role } = useAuth();
  const requiredRoles = location.state?.requiredRoles || [];
  const fromPath = location.state?.from;
  const dashboardPath =
    role === "admin" ? routePaths.admin : role === "trainer" ? routePaths.trainer : routePaths.student;

  return (
    <main className="unauthorized-page">
      <section className="unauthorized-card">
        <span>Access restricted</span>
        <h1>This CRM area is for QA Coder team members.</h1>
        <p>
          Your current role does not include access to this page. Lead CRM is available to
          admin and trainer accounts only.
        </p>

        <div className="unauthorized-meta">
          <div>
            <small>Your role</small>
            <strong>{role || "guest"}</strong>
          </div>
          {requiredRoles.length > 0 && (
            <div>
              <small>Allowed roles</small>
              <strong>{requiredRoles.join(", ")}</strong>
            </div>
          )}
          {fromPath && (
            <div>
              <small>Requested page</small>
              <strong>{fromPath}</strong>
            </div>
          )}
        </div>

        <div className="unauthorized-actions">
          <NavLink className="btn-ui" to={dashboardPath}>
            Go To Dashboard
          </NavLink>
          <NavLink className="btn-ui-secondary" to={routePaths.home}>
            Back Home
          </NavLink>
        </div>
      </section>
    </main>
  );
}
